// extracted by mini-css-extract-plugin
module.exports = {"page":"Delta3Series_page__JlCt2","spin":"Delta3Series_spin__a9kuk"};